<template>
  <div v-if="videos && channels" id="videos" class="z3 relative clearfix">
    <transition name="slide-fade">
      <div v-if="showSidebar" id="sidebar-wrapper" class="xs-hide sm-hide col col-5 md-col-4 lg-col-3">
        <videos-sidebar></videos-sidebar>
      </div>
    </transition>
    <div class="col" :class="getVideoClass">
      <div v-if="this.$route.name === 'Search' && searchTerm && searchResults !== null && searchResults.length === 0" class="m2">No Results...</div>
      <ul id="video-thumbnails" class="video-thumbnails flex flex-wrap content-start m0 px2 py3">
        <li v-if="searching"><loader></loader></li>
        <video-thumbnail v-for="video in videoList" :key="video.id" :video="video" :showSidebar="showSidebar"></video-thumbnail>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import VideosSidebar from '@/components/VideosSidebar'
import VideoThumbnail from '@/components/VideoThumbnail'
import Loader from '@/components/Loader'

export default {

  name: 'Video-Browser',

  components: {
    VideosSidebar,
    VideoThumbnail,
    Loader
  },

  data () {
    return {
      loading: false
    }
  },

  props: ['searchTerm'],

  computed: {
    ...mapState([
      'channels',
      'videos',
      'searchResults',
      'searching',
      'related'
    ]),
    showSearchResults: function () {
      if (this.$route.name === 'Search' && this.searchResults) {
        return true
      } else {
        return false
      }
    },
    showSidebar: function () {
      if (this.$route.fullPath.includes('/channels') || this.$route.fullPath.includes('/themes')) {
        return true
      } else {
        return false
      }
    },
    getVideoClass () {
      if (this.showSidebar) {
        return ['sm-col-7', 'md-col-8', 'lg-col-9']
      } else {
        return 'col-12'
      }
    },
    thumbnailWidth () {
      if (this.showSidebar) {
        return 'col-6'
      } else {
        return 'col-4'
      }
    },
    videoList () {
      if (this.$route.name === 'Search') {
        return this.searchResults
      } else if (this.$route.name === 'Related') {
        return this.related
      } else if (this.$route.name === 'Channels') {
        const channelSlug = this.$route.params.slug

        if (channelSlug) {
          const filtered = this.videos.filter(video => {
            if (video.channels !== null) {
              return Object.keys(video.channels).indexOf(channelSlug) > -1
            } else {
              return false
            }
          })
          return filtered
        } else {
          return this.videos
        }
      } else if (this.$route.name === 'Subchannel') {
        const channelSlug = this.$route.params.slug
        const subChannelSlug = this.$route.params.subChannelSlug

        if (subChannelSlug) {
          const filtered = this.videos.filter(video => {
            let subChannels = []
            if (video.channels !== null && channelSlug in video.channels) {
              Object.keys(video.channels).map(x => {
                if (x !== 'data') {
                  subChannels.push(
                    Object.values(video.channels[x]))
                }
              })
              return subChannels.reduce((acc, val) => acc.concat(val), []).indexOf(subChannelSlug) > -1
            } else {
              return false
            }
          })
          return filtered
        } else {
          return this.videos
        }
      } else if (this.$route.name === 'Themes') {
        const themeSlug = this.$route.params.themeSlug

        if (themeSlug) {
          const filtered = this.videos.filter(video => {
            if (video.themes) {
              return video.themes.some((theme) => theme.slug === themeSlug)
            } else {
              return false
            }
          })
          return filtered
        } else {
          return this.videos
        }
      } else {
        return this.videos
      }
    }
  },

  methods: {
    ...mapActions([
      'getChannels',
      'getVideos',
      'getThemes'
    ]),
    channelLink: function (channel) {
      return '/channels/' + channel.slug + this.$route.hash
    }
  },

  created: function () {
  }
}
</script>

<style lang="css" scoped>
  #sidebar-wrapper {
    position: sticky;
    top: 68px;
  }

  ul.video-thumbnails {
    list-style: none;
    min-height: calc(100vh - 68px);
  }
</style>



// WEBPACK FOOTER //
// src/components/VideoBrowser.vue